import { Component } from "@angular/core";

@Component({
    selector: "my-spinner",
    template: require('./spinner.component.html'),
    styles: [require('./spinner.component.scss')],
})
export class SpinnerComponent {
}
